/**
 * cdn链接前缀
 */
export const cdnHost = "https://glsp-img.unipus.cn/";

export const commonData = {
  umengAppKey: "65b0c93ba7208a5af1a2a3b2", // 友盟appkey
  sentryDns: "https://5c999fff5796d3f8b5e44d4d48ff5d44@sentry.golingo.cn/3" // sentry
};

// 获取url标识前缀
export const getNetTag = (): string => {
  if (window.location.hostname.includes(NETWORK_TYPE.LOCAL)) {
    return NETWORK_TYPE.LOCAL;
  } else if (window.location.hostname.includes(NETWORK_TYPE.UNIPUS)) {
    return NETWORK_TYPE.UNIPUS;
  } else {
    return NETWORK_TYPE.GOLINGO;
  }
};

// 域名pathname映射
export const NETWORK_TYPE = {
  GOLINGO: "golingo", // golingo域名
  UNIPUS: "unipus", // unipus域名
  LOCAL: "localhost" // 本地
};

// 需求方根据hostname区分链接映射
export const customerNetWorkUrl = {
  [NETWORK_TYPE.GOLINGO]: {
    local: "http://localhost:8067", //  local
    development: "https://dev-xq.golingo.cn", //  development
    test: "https://test-xq.golingo.cn", //  test
    test2: "https://test2-xq.golingo.cn", //  test2
    gray: "https://gray-xq.golingo.cn", //  gray
    prod: "https://xq.golingo.cn" //  prod
  },
  [NETWORK_TYPE.UNIPUS]: {
    local: "http://localhost:8067", //  local
    development: "https://dev-xq.unipus.cn", //  development
    test: "https://test-xq.unipus.cn", //  test
    test2: "https://test2-xq.unipus.cn", //  test2
    gray: "https://gray-xq.unipus.cn", //  gray
    prod: "https://xq.unipus.cn" //  prod
  },
  [NETWORK_TYPE.LOCAL]: {
    local: "http://localhost:8067", //  local
    development: "https://dev-xq.golingo.cn", //  development
    test: "https://test-xq.golingo.cn", //  test
    test2: "https://test2-xq.golingo.cn", //  test2
    gray: "https://gray-xq.golingo.cn", //  gray
    prod: "https://xq.golingo.cn" //  prod
  }
};

// 服务方根据hostname区分链接映射
export const providerNetWorkUrl = {
  [NETWORK_TYPE.GOLINGO]: {
    local: "http://localhost:8066", //  local
    development: "https://dev-fw.golingo.cn", //  development
    test: "https://test-fw.golingo.cn", //  test
    test2: "https://test2-fw.golingo.cn", //  test2
    gray: "https://gray-fw.golingo.cn", //  gray
    prod: "https://fw.golingo.cn" //  prod
  },
  [NETWORK_TYPE.UNIPUS]: {
    local: "http://localhost:8066", //  local
    development: "https://dev-fw.unipus.cn", //  development
    test: "https://test-fw.unipus.cn", //  test
    test2: "https://test2-fw.unipus.cn", //  test2
    gray: "https://gray-fw.unipus.cn", //  gray
    prod: "https://fw.unipus.cn" //  prod
  },
  [NETWORK_TYPE.LOCAL]: {
    local: "http://localhost:8066", //  local
    development: "https://dev-fw.golingo.cn", //  development
    test: "https://test-fw.golingo.cn", //  test
    test2: "https://test2-fw.golingo.cn", //  test2
    gray: "https://gray-fw.golingo.cn", //  gray
    prod: "https://fw.golingo.cn" //  prod
  }
};

// 官网根据hostname区分链接映射
export const homeNetWorkUrl = {
  [NETWORK_TYPE.GOLINGO]: {
    local: "http://localhost:3000", //  local
    development: "https://dev.golingo.cn", //  development
    test: "https://test.golingo.cn", //  test
    test2: "https://test2.golingo.cn", //  test2
    gray: "https://gray.golingo.cn", //  gray
    prod: "https://golingo.cn" //  prod
  },
  [NETWORK_TYPE.UNIPUS]: {
    local: "http://localhost:3000", //  local
    development: "https://dev-ie.unipus.cn", //  development
    test: "https://test-ie.unipus.cn", //  test
    test2: "https://test2-ie.unipus.cn", //  test2
    gray: "https://gray-ie.unipus.cn", //  gray
    prod: "https://glsp-ie.unipus.cn" //  prod
  },
  [NETWORK_TYPE.LOCAL]: {
    local: "http://localhost:3000", //  local
    development: "https://dev.golingo.cn", //  development
    test: "https://test.golingo.cn", //  test
    test2: "https://test2.golingo.cn", //  test2
    gray: "https://gray.golingo.cn", //  gray
    prod: "https://www.golingo.cn" //  prod
  }
};

// 判断环境
export const getEnv = (): string => {
  let hrefUrlName = "production";
  if (location.hostname.includes("localhost")) {
    hrefUrlName = "local";
  } else if (window.location.hostname.includes("dev")) {
    hrefUrlName = "development";
  } else if (window.location.hostname.includes("test2")) {
    hrefUrlName = "test2";
  } else if (window.location.hostname.includes("test")) {
    hrefUrlName = "test";
  } else if (window.location.hostname.includes("gray")) {
    hrefUrlName = "gray";
  }
  return hrefUrlName;
};

// url
export const Url = {
  // 服务商url 映射
  providerUrl: (): string => {
    const host = providerNetWorkUrl[getNetTag()];
    return host[process.env.ENV_NAME as keyof typeof host];
  },
  // 需求方url 映射
  customerUrl: (): string => {
    const host = customerNetWorkUrl[getNetTag()];
    return host[process.env.ENV_NAME as keyof typeof host];
  },
  // 官网url 映射
  golingoUrl: (): string => {
    const host = homeNetWorkUrl[getNetTag()];
    return host[process.env.ENV_NAME as keyof typeof host];
  }
};

// 路由中包含以下字段的，显示只有内容的框架
export const contentFramePath = ["protocol"];

// 平台标识
export enum PlatType {
  DEMAND = 0, // 需求方
  PROVIDER = 1 // 服务商
}
